import {React, useState} from "react";
import {deletePrinters} from "../../api/apiPrinter";
import Modal from "../common/Modal";

export const DeletePrinterComponent = (props) => {
    const { printer, successCallback, errorCallback } = props;
    const [showModal, setShowModal] = useState(false);

    const handleDelete = async () => {
        await deletePrinters(printer.id)
            .then(() => successCallback("L'imprimante a été supprimée."))
            .catch(() => errorCallback("Une erreur est survenue."));
    };
    const cancelModal = () => {setShowModal(false);}

    return (
        <>
            <button onClick={() => setShowModal(true)}>
                <i className="fa fa-times" />
            </button>
            {showModal && 
                <Modal
                    title="Supprimer une imprimante"
                    description={`Etes-vous sûr de vouloir supprimer l'imprimante <strong>${printer.name}</strong>?`}
                    buttons={[
                        {label: `Oui, supprimer <strong>${printer.name}</strong>`, callback: () => handleDelete()}
                    ]}
                    cancelCallback={() => cancelModal()}
                />
            }
        </>
    );
};